const getAllImages = (catalogue) => {
  if (!catalogue?.product) return [];

  return catalogue.product.flatMap((prod) => {
    if (!prod.image) return [];

    return prod.image.map((img, i) => ({
      original: img,
      mediumImage: prod.mediumImage?.[i] || null,
      thumbImage: prod.thumbImage?.[i] || null,
    }));
  });
};
export {getAllImages}